import { motion } from "framer-motion";

// All three step cards render user-provided full-card transparent posters —
// the artwork fills the card edge-to-edge and its transparent edges adopt
// the themed card colour (day/night).
const steps = [
  {
    n: "1",
    title: "Explore & Visit",
    body: "Browse participating campsites in the app and set out on your trip.",
    cardImage: "/assets/site/how-step1-poster.webp",
  },
  {
    n: "2",
    title: "Check In",
    body:
      "At the campsite, generate your QR — the owner scans and validates your stay.",
    cardImage: "/assets/site/how-step2-poster.webp",
  },
  {
    n: "3",
    title: "Collect Your Stamp",
    body:
      "Your unique campsite stamp lands in your passport with +100 XP. Level up.",
    cardImage: "/assets/site/how-step3-poster.webp",
  },
];

export default function HowItWorks() {
  return (
    <section
      data-testid="how-it-works"
      className="py-20 md:py-28"
      style={{ background: "var(--surface-secondary)" }}
    >
      <div className="wrap">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="eyebrow mb-4">How it works</div>
          <h2 className="section-title">
            From tent-up to stamp-collected in 3 steps.
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6 relative">
          {steps.map((s, i) => (
            <motion.article
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="card-elev relative overflow-hidden"
              style={{ padding: 0 }}
              data-testid={`step-card-${s.n}`}
            >
              <img
                src={s.cardImage}
                alt={`Step ${s.n}: ${s.title} — ${s.body}`}
                loading="lazy"
                className="w-full h-auto block"
                data-testid={`step-card-image-${s.n}`}
              />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
